export default __webpack_public_path__ + "static/media/completed-trades.9a4b10d1.svg";